import React from "react";
import { useNavigate } from "react-router-dom";
import ChatUI from "../components/chat/ChatUI";
import AppSidebarV2 from "../components/layout/AppSidebarV2";
import { useAuth } from "../auth/authStore";
import { useNotifications } from "../notifications/notificationsStore";

function displayRole(role) {
  const value = String(role || "").toUpperCase();
  if (value === "ADMIN") return "Администратор";
  if (value === "PSYCHOLOGIST") return "Психолог";
  if (value === "MODERATOR") return "Модератор";
  if (value === "CLIENT") return "Клиент";
  return role || "Пользователь";
}

function Chat() {
  const navigate = useNavigate();
  const { me, role } = useAuth();
  const { messageUnreadTotal = 0 } = useNotifications();
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const canOpenLiteratureEditor =
    role === "ADMIN" || role === "PSYCHOLOGIST" || role === "MODERATOR";
  const handleBack = React.useCallback(() => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate("/dashboard", { replace: true });
  }, [navigate]);

  return (
    <div className="podcasts-hub chat-shell-v2 chat-shell-v2--no-topbar chat-shell-v2--mobile-topbar">
      <div className="podcasts-shell">
        <AppSidebarV2
          activeKey="chat"
          mobileOpen={sidebarOpen}
          onCloseMobile={() => setSidebarOpen(false)}
          userName={me?.name || me?.login || "Гость"}
          roleLabel={displayRole(role)}
          canOpenLiteratureEditor={canOpenLiteratureEditor}
          chatBadge={messageUnreadTotal}
        />

        <button
          className={`podcasts-overlay ${sidebarOpen ? "is-open" : ""}`}
          type="button"
          aria-label="Закрыть меню"
          onClick={() => setSidebarOpen(false)}
        />

        <div className="podcasts-main">
          <header className="podcasts-topbar chat-mobile-topbar">
            <div className="podcasts-topbar__left chat-mobile-topbar__left">
              <button
                className="podcasts-topbar__menu-btn chat-mobile-topbar__icon-btn"
                type="button"
                onClick={handleBack}
                aria-label="Назад"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <button
                className="podcasts-topbar__menu-btn chat-mobile-topbar__icon-btn"
                type="button"
                onClick={() => setSidebarOpen(true)}
                aria-label="Открыть меню"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <line x1="3" y1="18" x2="21" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </button>
              <div className="chat-shell-v2__headline">
                <h1 className="chat-shell-v2__title">Чаты</h1>
                <p className="chat-shell-v2__sub">Сообщения и файлы</p>
              </div>
            </div>
          </header>
          <main className="chat-shell-v2__content">
            <ChatUI embedded />
          </main>
        </div>
      </div>
    </div>
  );
}

export default Chat;
